// extracted by mini-css-extract-plugin
export default {"root":"TermsOfService_root__jagBW","lastUpdated":"TermsOfService_lastUpdated__Vdfsr marketplaceBodyFontStyles","separator":"TermsOfService_separator__AfWX9"};